import isObject from 'lodash-es/isObject';
import isArray from 'lodash-es/isArray';
import debounce from 'lodash-es/debounce';
import store from '@/store';
import mutations from '@fps/vue-toolkit/dist/store/mutationlist'
import tempMutations from '@fps/vue-toolkit/dist/store/temp/temp.mutationlist'
import configProd from '@/./config.prod'
import configDev from '@/./config.dev'
import router from '@/router';

// eslint-disable-next-line import/prefer-default-export
export function objToFormData(obj, form, namespace) {
  const fd = form || new FormData();
  let formKey;

  Object.keys(obj)
    .forEach((property) => {
      formKey = namespace ? `${namespace}[${property}]` : property;

      if (obj[property] !== undefined) {
        if (
          isObject(obj[property])
          && obj[property] !== null
          && !(obj[property] instanceof File)
          && (!isArray(obj[property]) || obj[property].length)
        ) {
          objToFormData(obj[property], fd, formKey);
        } else {
          // if it's a string or a File object
          fd.append(formKey, obj[property]);
        }
      }
    });

  return fd;
}

export function overrideSave(Vue, { excludedStates, localStorageStateKey }) {
  const saveState = debounce(() => {
    const preppedState = {
      ...store.state,

      // Empty out temp
      ...excludedStates.reduce((prev, current) => ({ ...prev, [current]: {} }), {}),

      // Keep only token from auth state
      auth: {
        token: store.state.auth.token,
      },
    };
    localStorage.setItem(localStorageStateKey, JSON.stringify(preppedState));
  }, 500);

  // document.addEventListener('pause', () => {
    // alert('saving state');
    // saveState();
  // }, false);

  store.watch(state => state, { handler: saveState, deep: true });

  // window.onpagehide = () => {
  //   // alert('saving state');
  //   saveState();
  // };
}

export function overrideInit (Vue, options, next) {
  if (options.propagateState) {
    // Initialize store ( usually this is where you get the saved state from )
    store.commit(mutations.INIT_STORE, {
      excludedStates: options.excludedStates,
      storageKey: options.localStorageStateKey}
    )
  }


  // Load translations
  setTimeout(() => {
    store.dispatch('setLanguage', store.state.locale)
      .then(() => {
        store.commit(tempMutations.SET_INIT, true)

        next()
      })
  })

  if (options.propagateState) {
    this.handleStateSave(Vue, options)
  }
}

export function getConfig () {
  return process.env.NODE_ENV !== 'production' ? configDev : configProd
}

export function searchCategoryByKeywords (searched) {
  searched = searched.trim().toLowerCase();

  let category = null
  let subcategory = null

  // Find by subcategory first
  store.state.temp.categories.list
    .find((it1) => {
      return subcategory = it1.subcategories
        .find(it2 => router.app.$t(`subcategory.${it1.key}.${it2.key}`).toLowerCase() === searched)
    });

  if (subcategory) {
    category = store.state.temp.categories.list
      .find(it => it.subcategories.includes(subcategory));
  } else {
    category = store.state.temp.categories.list
      .find(it => router.app.$t(`category.${it.key}`).toLowerCase() === searched);
  }

  return {
    category,
    subcategory
  }
}



// WEBPACK FOOTER //
// ./src/utils.js